import { useQuery } from '@tanstack/react-query';

import { getFileUrl } from '../utils/axios';
import { queryKeys } from './queryKeys';

interface Params {
  projectId: string;
  documentationFileId: number;
  noRetry?: boolean;
  enabled?: boolean;
}

export function useInstallationPhoto({
  projectId,
  documentationFileId,
  noRetry = false,
  enabled = true,
}: Params) {
  const url = `/projects/${projectId}/documentation-files/${documentationFileId}/file`;

  const { data, error, isLoading, refetch, isFetching } = useQuery({
    queryKey: queryKeys.getInstallationPhoto(projectId, documentationFileId),
    queryFn: () => getFileUrl({ url }),
    enabled: !!projectId && !!documentationFileId && enabled,
    retry: !noRetry,
  });

  return {
    imgUrl: data,
    error,
    isLoading,
    isFetching,
    refetch,
  };
}
